import { render } from "./view-research-content-button.vue?vue&type=template&id=63463bac&scoped=true"
import script from "./view-research-content-button.vue?vue&type=script&lang=js"
export * from "./view-research-content-button.vue?vue&type=script&lang=js"

import "./view-research-content-button.vue?vue&type=style&index=0&id=63463bac&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63463bac"]])

export default __exports__